import Layout from "../layout/Layout";
import SEO from "../Components/SEO/SEO";
import ContactSection from "../sections/ContactSection";

export default function ContactPage() {
  return (
    <Layout>
      <SEO
        title="Contact Us | Quantum Spark Technology"
        description="Get a free project quote from Quantum Spark Technology. Email info@quantumsparktechnology.com or submit an inquiry — we respond within 24 hours."
        path="/contact"
      />
      <section className="border-b border-zinc-200 bg-[#FAFAFB] py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-6">
          <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-brand-purple">Contact</p>
          <h1 className="mb-4 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-brand-ink md:text-5xl">
            Talk to our team about your project
          </h1>
          <p className="max-w-2xl text-lg leading-relaxed text-brand-muted">
            Whether you need a new product built from scratch or help scaling an existing platform, share your goals and
            we will outline next steps for a discovery call. For careers and resumes, email{" "}
            <a href="mailto:support@quantumsparktechnology.com" className="font-medium text-brand-purple hover:underline">
              support@quantumsparktechnology.com
            </a>
            .
          </p>
        </div>
      </section>
      <ContactSection />
    </Layout>
  );
}
